import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from "react";
import { LocationsContextValue } from '../config/types'

const LocationsContext = createContext<LocationsContextValue | null>(null);

export function LocationsProvider({ children }: { children: any}) {
  const [LOCATIONS, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (hasLoadedRef.current && LOCATIONS.length > 0) return;

    const run = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/locations');
        const json = await res.json();

        setLocations(json);
        hasLoadedRef.current = true;
      } catch (e: any) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [LOCATIONS.length]);

  const value = useMemo(
    () => ({
      LOCATIONS,
      loading,
      error,
      refresh: async () => {
        hasLoadedRef.current = false;
        setLocations([]);
      },
    }),
    [LOCATIONS, loading, error]
  );

  return <LocationsContext.Provider value={value}>{children}</LocationsContext.Provider>;
}

export function useLocations() {
  const ctx = useContext(LocationsContext);
  if (!ctx) throw new Error("useLocations must be used within a LocationsProvider");
  return ctx;
}
